import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { isAuthenticated, startHostedUiLogin } from '@shared/auth/cognito';
import surelincLogo from '../assets/surelinc-logo.png';

type LocationState = {
  returnTo?: string;
};

export default function LoginPage() {
  const location = useLocation();
  const state = location.state as LocationState | null;
  const returnTo = state?.returnTo || '/';
  const [error, setError] = useState<string | null>(null);
  const [signingIn, setSigningIn] = useState(false);

  useEffect(() => {
    setError(null);
  }, [location.key]);

  if (isAuthenticated()) {
    return <Navigate to={returnTo} replace />;
  }

  async function signIn() {
    setSigningIn(true);
    setError(null);
    try {
      await startHostedUiLogin(returnTo);
    } catch (err) {
      setSigningIn(false);
      setError(err instanceof Error ? err.message : 'Unable to start sign in.');
    }
  }

  return (
    <div className="auth-page client-auth-page">
  <article className="auth-card">
    <div className="auth-brand client-auth-brand">
      <img className="client-auth-logo" src={surelincLogo} alt="SURELINC" />
      <div className="auth-brand-subtitle">Readiness Platform</div>
    </div>

    <div className="auth-login-content">
      <p>Use your assigned client account to access the SURELINC Readiness Platform.</p>
      {error && <p className="error-text">{error}</p>}
      <button className="primary-button" type="button" onClick={signIn} disabled={signingIn}>
        {signingIn ? 'Redirecting...' : 'Sign in'}
      </button>
    </div>
  </article>
</div>
  );
}
